import React from 'react';
import { COLORS } from '../../../app/common/constants/styles';
import styled from 'styled-components';
import { InfoTooltip } from '../../../app/common/components/InfoTooltip';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../app/common/components/Icon';
import ICONS from '../../../app/common/constants/icons';

export interface RevokeSessionLinkProps {
    onClick: () => void;
    isSessionRevoked: boolean;
    tooltipText?: FormattedMessage.MessageDescriptor | string;
    apiError?: any;
}

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const ToolTipWrapper = styled.div`
    position: absolute;
    right: 100%;
    bottom: 100%;
    margin-right: 2px;
`;

export const RevokeSessionButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    text-decoration: underline;
    text-align: left;
    color: ${COLORS.rakutenRed};
`;

export const IconWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
`;

export const RevokeSessionSuccessText = styled.span`
    color: ${COLORS.success};
`;

export const RevokeSessionErrorText = styled.span`
    color: ${COLORS.error};
`;

const RevokeSessionLink: React.FC<RevokeSessionLinkProps> = (props) => {
    const { onClick, isSessionRevoked, tooltipText, apiError } = props;

    return (
        <Wrapper>
            {!apiError
                ? getSessionRevocationLinkContents(onClick, isSessionRevoked, tooltipText)
                : getSessionRevocationFailedContents()}
        </Wrapper>
    );
};

const getSessionRevocationLinkContents = (
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined,
    isSessionRevoked: boolean,
    tooltipText: string | FormattedMessage.MessageDescriptor | undefined,
) => {
    return (
        <React.Fragment>
            {!isSessionRevoked ? (
                <React.Fragment>
                    {tooltipText && (
                        <ToolTipWrapper data-qa-id="revoke-session-info-tooltip">
                            <InfoTooltip
                                id="isSessionRevokeTooltip"
                                tooltipText={tooltipText}
                                uniqueId={'isSessionRevokeTooltip'}
                            />
                        </ToolTipWrapper>
                    )}
                    <RevokeSessionButton
                        data-qa-id="revoke-session-confirm-button"
                        onClick={onClick}
                    >
                        {TranslationHelpers.getFormattedMessage('revoke.session.button.text')}
                    </RevokeSessionButton>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <IconWrapper data-qa-id="revoke-session-success-icon">
                        <Icon
                            icon={ICONS.TICK}
                            size="16"
                            viewBoxMax="16"
                            fill={COLORS.success}
                            fillRule="evenodd"
                            clipRule="evenodd"
                        />
                    </IconWrapper>
                    <RevokeSessionSuccessText data-qa-id="revoke-session-success-text">
                        {TranslationHelpers.getFormattedMessage('revoke.session.success.text')}
                    </RevokeSessionSuccessText>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

const getSessionRevocationFailedContents = () => {
    return (
        <React.Fragment>
            <IconWrapper data-qa-id="revoke-session-notice-icon">
                <Icon
                    icon={ICONS.NOTICE}
                    size="16"
                    viewBoxMax="16"
                    fill={COLORS.error}
                    fillRule="evenodd"
                    clipRule="evenodd"
                />
            </IconWrapper>
            <RevokeSessionErrorText data-qa-id="revoke-session-error-text">
                {TranslationHelpers.getFormattedMessage('revoke.session.error.text')}
            </RevokeSessionErrorText>
        </React.Fragment>
    );
};

export default RevokeSessionLink;
